import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const WarningBadge2: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="border-transparent bg-destructive text-white">
      {t('component:badge.warning')}
    </Badge>
  );
};
